
const date = new Date()
const timeZoneOffset = -date.getTimezoneOffset() / 60

const formBoiler: any = {
    // Type: null,
    // TicketHistoryId: null,
    // FieldsValues: null,
    // SearchValues: null,
    // Latitude: null,
    // Longitude: null,
    // CustomFormDataId: null,
    Fields: [],
    // FieldTriggersToSave: null,
    // FormTriggerCollection: null,
    CustomFormId: null,
    CustomFormTypeId: null,
    Name: null,
    FieldsSchema: null,
    TriggerCollection: "",
    Enabled: false,
    AllowPics: false,
    AllowVids: false,
    EmployeeId: null,
    Color: null,
    ModifiedDate: null,
    ModifiedDateUTCOffset: timeZoneOffset,
    ModifiedBy: null,
    CreatedDate: null,
    CreatedDateUTCOffset: timeZoneOffset,
    CreatedBy: null,
    DeletedDate: null,
    DeletedDateUTCOffset: null,
    DeletedBy: null,
    AllowMapSketch: null,
    // FieldsToSave: null
}

export default formBoiler